// extracted by mini-css-extract-plugin
export var boxItems = "_8w-1";
export var boxItemsLg = "_8w-2";
export var button = "_8w-7";
export var buttonLg = "_8w-8";
export var filterGroupBox = "_8w-0";
export var icon = "_8w-3";
export var iconSecondary = "_8w-6";
export var iconWrapper = "_8w-4";
export var iconWrapperLg = "_8w-5";